import {Store} from 'redux'
import {IConfig} from '../core/interfaces/reducers'
import {ServiceHub} from '../core/ServiceHub'
import {IAppStore} from '../interfaces/reducers'
import {AppBgTransService} from './appBgTransService'
import {AppGisCrudService} from './crud/AppGisCrudService'
import {AppRemoteGisCrudService} from './crud/AppRemoteGisCrudService'
import {AppWfsCrudService} from './crud/AppWfsCrudService'
import {AppXYGisCrudService} from './crud/AppXYGisCrudService'
import {AppXyParser} from './crud/AppXyParser'
import {AppWFSLayerInfosService} from './layers/AppWFSLayerInfosService'
import {AppXyGisLayerInfosService} from './layers/AppXyGisLayerInfosService'
import {AppSourcesService} from './sources/AppSourcesService'

class AppServiceHubClass {
  initServices(config: IConfig, store: Store<IAppStore, any>): void {
    const xyParser = new AppXyParser()
    const WFSCrudService = new AppWfsCrudService(store)
    const XYGisCrudService = new AppXYGisCrudService(xyParser)
    const remoteGisCrudService = new AppRemoteGisCrudService(WFSCrudService, XYGisCrudService)
    const gisCrudService = new AppGisCrudService(remoteGisCrudService)
    const XyGisLayerInfosService = new AppXyGisLayerInfosService(gisCrudService)
    const WFSLayerInfosService = new AppWFSLayerInfosService()
    const sourcesService = new AppSourcesService(XyGisLayerInfosService, WFSLayerInfosService)

    ServiceHub.XyGisLayerInfosService = XyGisLayerInfosService
    ServiceHub.WFSLayerInfosService = WFSLayerInfosService
    ServiceHub.gisCrudService = gisCrudService
    ServiceHub.BgTransService = new AppBgTransService(config.urls.bgtransService)
    ServiceHub.SourcesService = sourcesService
  }
}

export const AppServiceHub = new AppServiceHubClass()
